import { useContext, useEffect, useState } from 'react';
import {
  CardHeader,
  Row,
  Col,
  Card,
  CardBody,
  Table,
  Button,
  Input,
  FormGroup,
  InputGroup,
  Collapse,
  Badge,
  ModalHeader,
  Modal,
  ModalBody,
} from 'reactstrap';

import api from 'services/api';
import { PropostaMaterialAvulso as IPropostaMaterialAvulso } from 'models/PropostaMaterialAvulso';
import { PropostaVersao } from 'models/PropostaVersao';
import AtividadeModel from 'models/ConfiguradorAtividade';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

import AutocompleteItemDomsge from 'components/AutocompleteItemDomsge';
import {
  FaFileExcel,
  FaPlusCircle,
  FaSync,
  FaSearch,
  FaEraser,
} from 'react-icons/fa';
import ItemDomsge from 'models/ItemDomsge';
import {
  Checkbox,
  CircularProgress,
  FormControlLabel,
  MenuItem,
  TextField,
  Tooltip,
} from '@material-ui/core';
import Select, { SingleValue } from 'react-select';
import toast from 'react-hot-toast';
import Produto from 'models/Produto';
import { PropostaContext } from 'views/pages/Proposta';
import { useQuery } from 'react-query';
import MaterialItem from 'views/pages/ConfiguracaoMateriais/components/MaterialItem';
import { useHistory, useLocation } from 'react-router-dom';
import ImportarExcel, {
  Opcoes,
} from 'views/pages/Proposta/components/ImportarExcel';
import AutocompleteItem, {
  iAutoCompleteItem,
} from 'components/AutocompleteItem';
import ProdutoAtividade from 'models/ProdutoAtividade';
import traduzirProdutoAtividade from 'utils/traduzirProdutoAtividade';
import { socket } from 'config/socket';
import { useAuth } from 'hooks/auth';
import formatCurrency from 'utils/formatCurrency';
import { arredondaDecimais } from 'utils/arredondaDecimais';
import './style.css';

import { ImportarExcelReturn } from 'models/ImportarExcelReturn';
import OrcamentoMaterial from 'models/OrcamentoMaterial';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import { Th, Td } from './styles';

// const MySwal = withReactContent(Swal);

interface LocationState {
  orcamentoId: number;
  orcamentoParteId: number;
  acessoLimitado: {
    acessoLimitado: boolean;
    temAcesso: boolean;
  };
}

interface Option {
  label: string;
  value: number;
}

export default function ConfiguracaoMaterialAvulso({
  setMateriaisAvulsosPlanilha,
  setDeveRecarregarComp,
  possuiMateriaisIndpie,
  orcamentoMateriais,
  loadingIndpie,
  setLoadingIndpie,
}: // recarregarLista,
{
  setMateriaisAvulsosPlanilha: React.Dispatch<React.SetStateAction<any[]>>;
  setDeveRecarregarComp: React.Dispatch<React.SetStateAction<boolean>>;
  possuiMateriaisIndpie: boolean;
  orcamentoMateriais: OrcamentoMaterial[];
  loadingIndpie: boolean;
  setLoadingIndpie: React.Dispatch<React.SetStateAction<boolean>>;
  /// recarregarLista: () => Promise<void>;
}): JSX.Element {
  const location = useLocation<LocationState>();
  const history = useHistory();
  const { usuario } = useAuth();
  const orcamentoId = location.state?.orcamentoId;
  const acessoLimitado = location.state?.acessoLimitado.acessoLimitado ?? true;
  const permiteModificacao = !acessoLimitado;
  // const [materiaisAvulsos, setMateriaisAvulsos] = useState<IPropostaMaterialAvulso[]>([]);
  const [loading, setLoading] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [itemDomsgeSelecionado, setItemDomsgeSelecionado] =
    useState<iAutoCompleteItem | null>(null);
  const [quantidadeNovoItem, setQuantidadeNovoItem] = useState(1);
  const [sequencia, setSequencia] = useState<number>();
  const [sequenciaIndpie, setSequenciaIndpie] = useState<number | null>(null);
  const [atividadeNovoItem, setAtividadeNovoItem] = useState<number>();
  const [atividades, setAtividades] = useState<ProdutoAtividade[]>([]);
  // const [produtos, setProdutos] = useState<Produto[]>([]);
  const [codEmpresa, setCodEmpresa] = useState('');

  const [produtos, setProdutos] = useState<Produto[]>([]);

  const [codigoOportunidadeDomsge, setCodigoOportunidadeDomsge] = useState();

  const [campoBusca, setCampoBusca] = useState('');
  const [mostrarFiltros, setMostrarFiltros] = useState(false);
  const [mostrarBotoes, setMostrarBotoes] = useState(false);

  const [loadingUpdateGrupo, setLoadingUpdateGrupo] = useState(false);
  const [mostrarModalIndpie, setMostrarModalIndpie] = useState(false);
  const [arrayCodSap, setArrayCodSap] = useState<ImportarExcelReturn[]>([]);
  const [versaoIndpie, setVersaoIndpie] = useState<null | number>(null);
  const [versaoIndpieInicial, setVersaoIndpieInicial] = useState<null | number>(
    null,
  );

  const [versoesIndpieDisponiveis, setVersoesIndpieDisponiveis] = useState<
    number[]
  >([]);

  const [produtoAtividadeCodSge, setProdutoAtividadeCodSge] = useState<
    string | null
  >(null);
  const [quantidadeMatSemErros, setQuantidadeMatSemErros] = useState<
    number | null
  >(null);
  const [quantidadeMatComErros, setQuantidadeMatComErros] = useState<
    number | null
  >(null);
  const [sessaoTempExcel, setSessaoTempExcel] = useState('');

  const options: Option[] = versoesIndpieDisponiveis.map(item => ({
    label: String(item),
    value: item,
  }));

  const optionsAtividade: { label: string; value: string }[] = atividades.map(
    item => ({
      label: `${item.codSAP} ${item.codSGE ? `(${item.codSGE})` : ''}`,
      value: item?.codSGE ?? '',
    }),
  );

  const selectedValue = versaoIndpie ?? versaoIndpieInicial;

  async function handleExportToSheet() {
    const response = await api.get<Blob>('/indpie/xlsx', {
      params: {
        sessao: sessaoTempExcel,
      },
      responseType: 'blob',
    });

    const contentType = response.headers['content-type'];

    // Provavelmente desnecessário, mas só pra garantir
    if (!contentType?.includes('spreadsheetml')) {
      Swal.fire({
        icon: 'error',
        title: 'Ops!',
        text: 'Resposta não é um arquivo Excel',
      });
      return;
    }

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    // Nome do arquivo
    a.download = `materiais-indpie.xlsx`;

    document.body.appendChild(a);
    a.click();

    a.remove();
    window.URL.revokeObjectURL(url);
  }

  function limparCampos() {
    setVersaoIndpie(versaoIndpieInicial);
    setLoadingIndpie(false);
    setMostrarModalIndpie(false);
    setQuantidadeMatSemErros(null);
    setQuantidadeMatComErros(null);
    setSessaoTempExcel('');
    setArrayCodSap([]);
    setProdutoAtividadeCodSge(null);
    setSequenciaIndpie(null);
  }

  async function returnMateriais(): Promise<any[]> {
    const response = await api.get(`/orcamento/${orcamentoId}/material-avulso`);
    return response.data;
  }

  async function carregaProdutos() {
    const response = await api.get(`/produto/configuracao/${orcamentoId}`);

    setProdutos(response.data);
    setCodEmpresa(response.data[0]?.codigoEmpresa);
  }

  async function listaAtividades(id: number) {
    const response = await api.get(`/produto-atividade?produtoId=${id}`);
    setAtividades(response.data);
  }

  useEffect(() => {
    if (produtos && produtos.length) {
      listaAtividades(produtos[0].id);
    }
  }, [produtos]);

  async function buscaVersoesIndpie() {
    const response = await api.get<
      {
        VERSAO: number;
      }[]
    >('/indpie/versoes', {
      params: {
        gnf: codigoOportunidadeDomsge,
      },
    });

    setVersoesIndpieDisponiveis(
      response.data.map((item: { VERSAO: number }) => item.VERSAO),
    );
  }

  useEffect(() => {
    if (codigoOportunidadeDomsge) {
      buscaVersoesIndpie();
    }
  }, [codigoOportunidadeDomsge]);

  async function carregaMateriaisAvulsos(): Promise<void> {
    try {
      // setLoading(true);
      const data = await returnMateriais();
      // setMateriaisAvulsos(data);
      setMateriaisAvulsosPlanilha(data);
      const response2 = await api.post(
        '/orcamento/verifica-material-titulo-sequencia',
        {
          orcamentoId,
        },
      );
    } finally {
      // setLoading(false);
      setDeveRecarregarComp(true);
    }
  }

  async function pegarDadosOrcamento() {
    const orcamento = await api.get(`/orcamento/versao/${orcamentoId}`);
    const {
      codigoOportunidadeDomsge: gnf,
      versaoIndpie: versaoIndpieCadastrada,
    } = orcamento.data.orcamento;
    setVersaoIndpieInicial(versaoIndpieCadastrada);
    setVersaoIndpie(versaoIndpieCadastrada);
    setCodigoOportunidadeDomsge(gnf);
  }

  function handleOpenModal() {
    setMostrarModalIndpie(true);
    setArrayCodSap([]);
  }

  async function handleIntegrarMateriaisSemErro(
    executarSemAbrirModa: boolean | null = null,
    qntMateriaisSemErro?: number,
    sessao?: string,
  ) {
    setLoadingIndpie(true);
    if (executarSemAbrirModa) {
      setMostrarModalIndpie(false);
      Swal.fire({
        icon: 'info',
        text: `Importando ${qntMateriaisSemErro} materiais`,
        allowOutsideClick: false,
        showConfirmButton: false,
      });
    } else {
      toast.loading(`Importando materiais do INDPIE`);
    }
    await api.post(`/proposta/configuracao/${orcamentoId}/importar-dados`, {
      sessao: sessao ?? sessaoTempExcel,
      isIndpie: true,
      versaoIndpie,
      produtoId: produtos[0].id,
      produtoAtividadeCodSge,
      gnf: codigoOportunidadeDomsge,
      sequenciaIndpie,
    });

    setVersaoIndpieInicial(versaoIndpie);
    Swal.close();
    toast.dismiss();
    toast.success(`Materiais importados com sucesso`);
    // Reseta propriedades
    setLoadingIndpie(false);
    setMostrarModalIndpie(false);
    setQuantidadeMatSemErros(null);
    setQuantidadeMatComErros(null);
    setProdutoAtividadeCodSge(null);
    setSequenciaIndpie(null);
    // setVersaoIndpie(null);

    carregaMateriaisAvulsos();
    setDeveRecarregarComp(true);
  }

  async function handleExportToSheet2() {
    const response = await api.get<Blob>('/indpie/xlsx', {
      params: {
        sessao: sessaoTempExcel,
      },
      responseType: 'blob',
    });

    const contentType = response.headers['content-type'];

    // Provavelmente desnecessário, mas só pra garantir
    if (!contentType?.includes('spreadsheetml')) {
      Swal.fire({
        icon: 'error',
        title: 'Ops!',
        text: 'Resposta não é um arquivo Excel',
      });
      return;
    }

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    // Nome do arquivo
    a.download = `materiais-indpie.xlsx`;

    document.body.appendChild(a);
    a.click();

    a.remove();
    window.URL.revokeObjectURL(url);
  }

  async function handleIndpie() {
    setLoadingIndpie(true);
    toast.loading('Buscando materiais do INDPIE');
    if (!versaoIndpie) {
      Swal.fire({
        icon: 'error',
        title: 'Ops!',
        text: 'É necessário informar uma versão',
      });
      setLoadingIndpie(false);
      toast.dismiss();
      return;
    }
    try {
      const response = await api.get<{
        registrosComErro: ImportarExcelReturn[];
        qntRegistrosSemErro: number;
        qntRegistrosComErro: number;
        sessao: string;
      }>('/indpie', {
        params: {
          gnf: codigoOportunidadeDomsge,
          versao: versaoIndpie,
          emprCodigo: produtos[0].codigoEmpresa,
          orcamentoId,
          produtoAtividadeCodSge,
          sequenciaIndpie,
        },
      });

      const quantidadeSemErros = response.data.qntRegistrosSemErro;
      const quantidadeComErros = response.data.qntRegistrosComErro;

      const { sessao } = response.data;

      setArrayCodSap(response.data.registrosComErro);
      setSessaoTempExcel(sessao);
      setQuantidadeMatSemErros(quantidadeSemErros);
      setQuantidadeMatComErros(quantidadeComErros);

      if (quantidadeComErros === 0) {
        toast.dismiss();
        await handleIntegrarMateriaisSemErro(true, quantidadeSemErros, sessao);
      }

      // setMostrarModalIndpie(true);
    } catch (error: any) {
      console.log(error);
      Swal.fire({
        icon: 'error',
        title: 'Ops!',
        text:
          error?.response?.data?.message ??
          'Não foi possível prosseguir com o salvamento',
      });
    } finally {
      setLoadingIndpie(false);
      toast.dismiss();
    }
  }

  useEffect(() => {
    pegarDadosOrcamento();
    carregaMateriaisAvulsos();
    carregaProdutos();
  }, []);

  // useEffect(() => {
  //   if (codigoOportunidadeDomsge) {
  //     buscaVersoesIndpie();
  //   }
  // }, [codigoOportunidadeDomsge]);

  const [resetKey, setResetKey] = useState(0);

  async function addMaterialAvulso() {
    if (!itemDomsgeSelecionado) {
      return;
    }
    try {
      setUpdating(true);
      const { id } = itemDomsgeSelecionado;
      const orcamentoMaterialCriado = await api.post(
        `/orcamento/${orcamentoId}/material-avulso`,
        {
          materialId: itemDomsgeSelecionado.id,
          quantidade: quantidadeNovoItem,
          atividade: atividadeNovoItem,
          sequencia,
        },
      );
      setItemDomsgeSelecionado(null);
      setQuantidadeNovoItem(1);
      // setAtividadeNovoItem(undefined);
      // setSequencia(undefined);
      setResetKey(prev => prev + 1);
      carregaMateriaisAvulsos();
      setUpdating(false);

      // await recarregarLista();
      const response2 = await api.post(
        '/orcamento/verifica-material-titulo-sequencia',
        {
          orcamentoId,
        },
      );

      setDeveRecarregarComp(true);
      toast.success('Material adicionado com sucesso!', {
        position: 'top-right',
      });

      socket.emit('update_config', {
        configId: orcamentoId,
        materiaisModificados: [orcamentoMaterialCriado.data],
        tipo: 'criar',
        user: {
          id: usuario.id,
          nome: usuario.nome,
        },
      });
    } finally {
      setUpdating(false);
    }
  }

  useEffect(() => {
    if (updating) {
      toast.loading('Aguarde...', { position: 'top-right' });
      return;
    }

    toast.dismiss();
  }, [updating]);

  function handleSelecionarItem(itemDomsge: iAutoCompleteItem | null) {
    setItemDomsgeSelecionado(itemDomsge);
  }

  // function handleOpenModal() {
  //   setMostrarModalIndpie(true);
  //   setArrayCodSap([]);
  // }

  // function mostrarBadgesFiltro() {
  //   const badges = [];

  //   if (atividadeFiltro) {
  //     badges.push(
  //       <Badge color="warning" key="atividade">
  //         Atividade
  //       </Badge>,
  //     );
  //   }
  //   if (sequenciaFiltro) {
  //     badges.push(
  //       <Badge color="info" key="sequencia">
  //         Sequência
  //       </Badge>,
  //     );
  //   }
  //   if (campoBusca) {
  //     badges.push(
  //       <Badge color="success" key="descricao">
  //         Descrição
  //       </Badge>,
  //     );
  //   }

  //   return <>{badges}</>; // Fragment to render multiple elements
  // }

  return (
    <>
      <CardHeader>
        <Modal
          className="custom-modal"
          size="xl"
          isOpen={mostrarModalIndpie}
          toggle={() => setMostrarModalIndpie(prev => !prev)}
          onClosed={limparCampos}
        >
          <div className="modal-body p-0">
            <Card className="bg-secondary shadow border-0">
              <ModalHeader toggle={() => setMostrarModalIndpie(prev => !prev)}>
                <div className="text-center text-muted">
                  Lista de materiais INDPIE importados
                </div>
              </ModalHeader>
              <ModalBody className="px-lg-5">
                <Row className="d-flex align-items-end">
                  <Col sm="2" className="">
                    <div className="field">
                      <label htmlFor="versao-indpie">Versão INDPIE</label>

                      <Select
                        inputId="versao-indpie"
                        placeholder="Selecione..."
                        options={options}
                        isSearchable={false}
                        isDisabled={loadingIndpie}
                        value={
                          options.find(o => o.value === selectedValue) ?? null
                        }
                        onChange={option =>
                          setVersaoIndpie(option?.value ?? null)
                        }
                      />
                    </div>
                  </Col>

                  <Col sm="3" className="">
                    <div className="field">
                      <label htmlFor="produto-atividade">Atividade</label>
                      <Select
                        inputId="produto-atividade"
                        placeholder="Atividade"
                        isClearable
                        isDisabled={loadingIndpie || !versaoIndpie}
                        options={optionsAtividade}
                        isSearchable={false}
                        // isDisabled={loadingIndpie || !versaoIndpie}
                        value={
                          optionsAtividade.find(
                            o => o.value === produtoAtividadeCodSge,
                          ) ?? null
                        }
                        onChange={option => {
                          setProdutoAtividadeCodSge(option?.value ?? null);

                          if (!option) {
                            setSequenciaIndpie(null);
                          }
                        }}
                      />
                    </div>
                  </Col>

                  <Col sm="3" className="">
                    <div className="field">
                      <label htmlFor="produto-atividade">Sequência</label>
                      <Input
                        type="number"
                        min={1}
                        pattern="[0-9]*"
                        placeholder="Sequência"
                        disabled={
                          loadingIndpie ||
                          !optionsAtividade.find(
                            o => o.value === produtoAtividadeCodSge,
                          ) ||
                          loadingIndpie
                        }
                        value={sequenciaIndpie ?? ''}
                        style={{
                          height: '38px',
                          minHeight: '38px',
                          padding: '0 12px',
                          lineHeight: '38px',
                          boxSizing: 'border-box',
                        }}
                        onChange={event =>
                          setSequenciaIndpie(parseInt(event.target.value, 10))
                        }
                      />
                    </div>
                  </Col>

                  <Col sm="1" className="">
                    {versaoIndpieInicial !== null &&
                    versaoIndpieInicial === versaoIndpie ? (
                      <Button
                        size="sm"
                        disabled={loadingIndpie}
                        className="btn-icon btn-2"
                        color="info"
                        type="button"
                        style={{ height: 36, width: 50 }}
                        onClick={handleIndpie}
                      >
                        <FaSync />
                      </Button>
                    ) : (
                      <Button
                        size="sm"
                        disabled={loadingIndpie}
                        className="btn-icon btn-2"
                        color="primary"
                        type="button"
                        style={{ height: 36, width: 50 }}
                        onClick={handleIndpie}
                      >
                        <FaPlusCircle />
                      </Button>
                    )}
                  </Col>
                </Row>

                <Row hidden={!versaoIndpieInicial} className="mt-2">
                  <p
                    style={{
                      color: 'red',
                    }}
                  >
                    {produtoAtividadeCodSge
                      ? `Ao importar os materiais, dados previamente importados com o código de atividade ${
                          optionsAtividade.find(
                            o => o.value === produtoAtividadeCodSge,
                          )?.label ?? ''
                        }${
                          sequenciaIndpie !== null &&
                          sequenciaIndpie !== undefined
                            ? ` e sequência ${sequenciaIndpie}`
                            : ''
                        } serão excluídos.`
                      : 'Ao importar os materiais, dados previamente importados serão excluídos'}
                  </p>
                </Row>

                <Row
                  hidden={!((quantidadeMatSemErros ?? 0) > 0)}
                  className="mt-2"
                >
                  Quantidade de materiais para importar: {quantidadeMatSemErros}
                  <Button
                    size="sm"
                    disabled={loadingIndpie}
                    className="btn-icon btn-2 ml-4"
                    color="primary"
                    hidden={quantidadeMatSemErros === 0}
                    type="button"
                    onClick={() => handleIntegrarMateriaisSemErro()}
                  >
                    Importar {quantidadeMatSemErros}{' '}
                    {(quantidadeMatSemErros ?? 0) > 1
                      ? 'materiais'
                      : 'material'}
                  </Button>
                </Row>
                <Row
                  hidden={!((quantidadeMatComErros ?? 0) > 0)}
                  className="mt-4"
                >
                  Quantidade de materiais inválidos: {quantidadeMatComErros}
                </Row>

                <Row
                  // hidden={!arrayCodSap.find(item => item.itemEncontrado)}
                  hidden={!((quantidadeMatComErros ?? 0) > 0)}
                  className="mt-4"
                >
                  <Col
                    sm="8"
                    style={{ display: 'flex', flexDirection: 'column' }}
                  >
                    <p className="mb-0" style={{ textDecoration: 'underline' }}>
                      Os materiais marcados em vermelho não serão importados,
                      verifique:
                    </p>
                    <ul className="ml-0" style={{ fontSize: '11px' }}>
                      <li>
                        <strong style={{ color: '#f55044' }}>Vermelho:</strong>{' '}
                        Material não cadastrado no SGE/SAP (não será importado).
                      </li>
                      <li>
                        <strong style={{ color: '#d4b106' }}>Amarelo:</strong>{' '}
                        Material zerado / sem valor parametrizado (será
                        importado).
                      </li>
                    </ul>
                  </Col>

                  <Col
                    sm="4"
                    className="mb-0 d-flex flex-column justify-content-end align-items-end"
                    hidden={!((quantidadeMatComErros ?? 0) > 0)}
                  >
                    <Button
                      size="sm"
                      className="btn-icon btn-2  float-right"
                      style={{ backgroundColor: '#1a8c5b', width: '240px' }}
                      color="success"
                      type="button"
                      onClick={handleExportToSheet}
                    >
                      <FaFileExcel />
                      <span className="btn-inner--text">Exportar planilha</span>
                    </Button>
                  </Col>
                </Row>

                <Row hidden={!((quantidadeMatComErros ?? 0) > 0)}>
                  <Col
                    sm="12"
                    className=" mt-3"
                    style={{ height: '300px', overflowY: 'scroll' }}
                  >
                    <Table
                      className="align-items-center table-flush"
                      responsive
                    >
                      <thead className="thead-light">
                        <tr>
                          <th>Código</th>
                          <th>Descrição</th>
                          <th>Sequência</th>
                          <th>Quantidade</th>
                          <th>Atividade</th>
                        </tr>
                      </thead>
                      <tbody>
                        {arrayCodSap
                          .filter(
                            item =>
                              !item.itemEncontrado || !item.valorEncontrado,
                          )
                          .map((item: any) => {
                            const erroItem = !item.itemEncontrado;

                            const possuiErro = !item.valorEncontrado;
                            let style;

                            if (erroItem) {
                              style = {
                                backgroundColor: '#f55044',
                                color: '#FFFFFF',
                              };
                            } else if (possuiErro) {
                              style = {
                                backgroundColor: '#f5e344ff',
                                color: '#FFFFFF',
                              };
                            }

                            return (
                              <tr key={item.id} style={{ ...style }}>
                                <td className="py-1">{item.codigo}</td>
                                <td
                                  className="py-1"
                                  style={{
                                    wordBreak: 'break-word',
                                    whiteSpace: 'normal',
                                  }}
                                >
                                  {item.descricao}
                                </td>
                                <td className="py-1">{item.sequencia}</td>
                                <td className="py-1">{item.quantidade}</td>
                                <td className="py-1">{item.atividade}</td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </ModalBody>
            </Card>
          </div>
        </Modal>
        {/* <Row className="align-items-center">
          <Col sm="7">
            <h4 className="mb--1">Materiais avulsos da configuração</h4>
            <small className="text-muted"> </small>
          </Col>
          <Col sm="3">
            <ImportarExcel
              propostaVersaoId={1}
              tipo="lista de materiais"
              opcoes={'Configuracao' as any}
              configuracaoId={orcamentoId}
              isSinergia
              callbackFn={carregaMateriaisAvulsos}
            />
          </Col>
          <Col sm="4" className="d-flex align-items-center">
            <Button
              size="sm"
              disabled={loadingIndpie}
              className="btn-icon btn-2 mr-1 m-3 "
              // style={{ height: 40 }}
              color="primary"
              type="button"
              onClick={handleOpenModal}
            >
              Importar INDPIE
            </Button>
          </Col>
          <Col sm="2">
            <Button
              size="sm"
              disabled={updating}
              className="btn-icon btn-2"
              style={{ backgroundColor: '#1a8c5b' }}
              color="success"
              type="button"
              onClick={() => {
                // eslint-disable-next-line no-restricted-globals
                history.push({
                  pathname: `/admin/configurador-itens-lote`,
                  state: { orcamentoId, emprCodigo: codEmpresa },
                });
              }}
            >
              <span className="btn-inner--text">Cadastro em lote</span>
            </Button>
          </Col>
        </Row> */}
      </CardHeader>

      {permiteModificacao && (
        <>
          <Card className="ml-4">
            <Row className="pr-2">
              <Col sm="12">
                <CardHeader>
                  <Row className="align-items-center">
                    <Col
                      sm="3"
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                      }}
                    >
                      <h4 className="mb--1">
                        Materiais avulsos da configuração
                      </h4>
                      <button
                        className="mb--1"
                        type="button"
                        style={{
                          background: 'none',
                          border: 'none',
                          padding: '0',
                          font: 'inherit',
                          cursor: 'pointer',
                        }}
                        onClick={() =>
                          setMostrarBotoes(mstBotoes => !mstBotoes)
                        }
                      >
                        {mostrarBotoes ? <ExpandLess /> : <ExpandMore />}{' '}
                      </button>
                    </Col>

                    <Col
                      sm="6"
                      style={{
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                        gap: '8px',
                      }}
                    >
                      <ImportarExcel
                        propostaVersaoId={1}
                        tipo="lista de materiais"
                        opcoes={Opcoes.Configuracao}
                        configuracaoId={orcamentoId}
                        isSinergia
                        callbackFn={carregaMateriaisAvulsos}
                      />

                      <Button
                        size="sm"
                        disabled={loadingIndpie}
                        className="btn-icon btn-2"
                        color="primary"
                        type="button"
                        onClick={handleOpenModal}
                      >
                        Importar INDPIE
                      </Button>

                      <Button
                        size="sm"
                        className="btn-icon btn-2"
                        style={{ backgroundColor: '#1a8c5b' }}
                        color="success"
                        type="button"
                        onClick={() => {
                          history.push({
                            pathname: `/admin/configurador-itens-lote`,
                            state: { orcamentoId, emprCodigo: codEmpresa },
                          });
                        }}
                      >
                        <span className="btn-inner--text">
                          Cadastro em lote
                        </span>
                      </Button>
                    </Col>
                  </Row>
                </CardHeader>
              </Col>
              <Col sm="12">
                <Collapse isOpen={mostrarBotoes}>
                  <AutocompleteItem
                    key={resetKey}
                    hideTitle
                    handleSelecionarItem={handleSelecionarItem}
                    maxWidth="40vw"
                    noAutoFocus
                    emprCodigo={codEmpresa}
                  >
                    <Input
                      type="number"
                      min={1}
                      pattern="[0-9]*"
                      className="ml-2"
                      value={quantidadeNovoItem}
                      onChange={event =>
                        setQuantidadeNovoItem(parseInt(event.target.value, 10))
                      }
                    />

                    <Input
                      className="ml-2"
                      type="select"
                      value={atividadeNovoItem !== 0 ? atividadeNovoItem : ''}
                      onChange={text =>
                        setAtividadeNovoItem(Number(text.target.value))
                      }
                    >
                      <option value="">Atividade</option>
                      {atividades.map(atividade => (
                        <option
                          value={atividade.id}
                          title={
                            atividade.codSGE
                              ? `Ref. DomSGE: ${atividade.codSGE}`
                              : ''
                          }
                        >
                          {traduzirProdutoAtividade(atividade)}
                        </option>
                      ))}
                    </Input>

                    <Input
                      type="number"
                      min={1}
                      pattern="[0-9]*"
                      placeholder="Sequência"
                      className="ml-2"
                      value={sequencia}
                      onChange={event =>
                        setSequencia(parseInt(event.target.value, 10))
                      }
                    />
                    <Button
                      disabled={updating}
                      className="btn-icon btn-2"
                      color="primary"
                      type="button"
                      onClick={addMaterialAvulso}
                    >
                      <FaPlusCircle />
                    </Button>
                  </AutocompleteItem>
                </Collapse>
              </Col>
            </Row>
          </Card>
        </>
      )}

      {/* <Card>
        <CardBody className="p-1">
          {loading ? (
            <Row>
              <Col className="text-center mb-4 mt-4">
                <CircularProgress />
              </Col>
            </Row>
          ) : (
            <Table bordered responsive>
              <thead>
                <tr>
                  <Th>Ativ</Th>
                  <Th>Item</Th>
                  <Th className="text-center">Quantidade</Th>
                  {materiaisAvulsos.length > 0 && permiteModificacao && <Th />}
                </tr>
              </thead>
              <tbody>{Materiais()}</tbody>
            </Table>
          )}
        </CardBody>
      </Card> */}
    </>
  );
}
